/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBrandDolbyDigital = createSolidComponent(
  "brand-dolby-digital",
  "IconBrandDolbyDigital",
  [
    [
      "path",
      {
        d: "M21 6v12h-.89c-3.34 0 -6.047 -2.686 -6.047 -6s2.707 -6 6.046 -6h.891z"
      }
    ],
    [
      "path",
      {
        d: "M3.063 6v12h.891c3.34 0 6.046 -2.686 6.046 -6s-2.707 -6 -6.046 -6h-.89z"
      }
    ]
  ]
);

export { IconBrandDolbyDigital as default };
//# sourceMappingURL=IconBrandDolbyDigital.js.map
